import AddOnsCard from './AddOnsCard'

export default AddOnsCard